import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useEmailState(emailId: string) {
	const query = useQuery({
		queryKey: ["email", emailId, "state"],
		queryFn: async () => {
			const response = await client.emails[":emailId"].state.$get({
				param: { emailId },
			});
			const data = await responseHandler(response);
			return data.state;
		},
	});

	return { ...query, state: query.data };
}
